export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10845.9bbce5c6.jpg";